import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'
import NutritionLabel from './NutritionLabel.jsx'

import { translate } from 'react-i18next';

var FiberOnly = React.createClass({

  getInitialState() {

    this.state = {
      email: '',
      emailError: false,
      standardSelected: "fusion"
    };

    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {

    AvailabilityStore.listen(this.onChange);
    window.scrollTo(0, 0);
    document.body.classList.add('long-scroll');
    this.setState({"standardSelected" : "fusion"});

    const emailCookie = this.getCookieValue("SESSemail");

    if (emailCookie != '') {
      this.setState({'email': emailCookie});
    }
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  handleChange(event) {
    this.setState({'email': event.target.value});
  },

  backToStepOne() {
    AvailabilityActions.backToStepOne();
  },

  highlightProduct(selectedProduct) {
    this.setState({"standardSelected" : selectedProduct});
    localStorage.setItem("standardSelected", selectedProduct);
},

  selectProduct(product,collectEmail) {


      let domain = (window.cookie_domain ? window.cookie_domain : 'sonic.com');
      let expires = (new Date);

      expires.setTime((new Date).getTime()+(30*24*60*60*1000)); // Set to 30 days so the cookie itself doesn't end up expiring before a normal A/B exposure test would.

      let select_to_signup = true;
      const emailAddress = this.state.email;
      if (collectEmail && !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(emailAddress)) {
        this.setState({'emailError':true});
        event.preventDefault();
        return;
      }

      if (collectEmail) {
        document.cookie = "SESSemail="+emailAddress+"; domain="+domain+"; path=/;";
      }

      if(select_to_signup) {
          var form = document.createElement('form');
          form.method = 'POST';
          form.action = this.state.store.get('signup_submit_target');

          var inputs = [
              ['extra_data', this.state.store.get('extraData')],
              ['referral_code', this.state.store.get('referralCode')],
              ['coupon_code', (product.promo && product.promo.code ? product.promo.code : '')],
              ['prequal_key', this.state.store.get('prequal_tracking_key')],
              ['product_key', product.product_key],
              ['coupon_history', (window.coupon_history ? window.coupon_history : []) ],
              ['sso_user', this.state.store.get('sso_user')],
              ['sonic_elq_customerID', this.state.store.get('sonic_elq_customerID')],
              ['emailAddress', emailAddress]
          ];
          inputs.forEach(function(v) {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = v[0];
              input.value = v[1];
              form.append(input);
          })

          document.body.append(form);
          form.submit();
          AvailabilityActions.placeOrder();
      }

    AvailabilityActions.selectProduct(product);
  },

  getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  },

  render() {
      const { t, show_voice_only } = this.props;
      var store = this.state.store;
      var products = store.get('products').toJS();
      let fusion_product, gpon_voice_product = undefined;
      let fusion_pricing, gpon_voice_pricing = undefined;
      let test_product = []; // This will be to cature and use test_drive products.
      let coupon_banner = '';

      products.forEach(item=>{
        if (item.product_key == 'fusion_fiber'){
          fusion_product = item;
        }
        if (item.product_key == 'fusion_fiber_test_drive'){
          test_product = item;
        }
        if (item.product_key == 'gpon_voice'){
          gpon_voice_product = item;
          gpon_voice_pricing = gpon_voice_product.mrc;
      }
      })

      let product = fusion_product;

      // let product_pricing = fusion_pricing;
      // if (this.state.standardSelected == "standard") {
      //     product_pricing = standard_pricing;
      // }else if (this.state.standardSelected == "gpon_voice"){
      //     product_pricing = gpon_voice_pricing;
      // }

      var displayPrice = parseFloat(product.mrc);
      let productRegularPrice = parseFloat(product.mrc);
      if(product.show_mrc_and_extra_fees_as_flat_rate) {
          let extraFeesTotal = product.extra_fees.reduce(function(carry, fee) {
              var feePrice = parseFloat(fee[1]);
              if(feePrice < 0) {
                  return carry;
              }
              carry += feePrice;
              return carry;
          }, 0.00);
          displayPrice += extraFeesTotal;
          productRegularPrice += extraFeesTotal;
      }

      // go directly to signup for this free-fiber-for-schools-with-rental-no-contract coupon type.
      if (product.promo && product.promo.coupon_type_id && product.promo.coupon_type_id == 52) {
          this.selectProduct(product, false);
      }

      var display_promo_amount = 0;
      var display_promo_duration = 0;
      if (product.promo && product.promo.hasOwnProperty('discount duration')) {
        display_promo_duration = product.promo['discount duration'];
      }
      var banner_addition = '';
      var promo_amount = 0;
      var promo_name = '';

      if(product.promo && product.promo.coupon_type_id && (product.promo.coupon_type_id == 38|| product.promo.coupon_type_id == 47)) {
          banner_addition = <div>Save $12 for 6 months on Whole-Home WiFi</div>;
      }
      if(product && product.promo) {
        promo_amount = product.promo['discount amount'];
      }

      if(product.promo && product.promo['coupon type'] && product.promo['coupon type'] == 'free month') {
        coupon_banner = product.promo['description display'];
      }

      if(product && product.promo) {
        promo_amount = product.promo['discount amount'];
        promo_name = product.promo.name;
        // all X month free promos under 1 year should show 10 off the display price
        if(promo_amount == 'free' || promo_amount == '6free' || promo_amount == '4free' || promo_amount == '3free' || promo_amount == '2free') {
            promo_amount = 10;
            display_promo_duration = 12;
        }
        else if(promo_amount == '12free') {
            promo_amount = 0;
            display_promo_duration = 12;
        } else {
            promo_amount = parseFloat(promo_amount);
        }
      }

      displayPrice =  Number(displayPrice - promo_amount).toFixed(2).replace('.00', '');
      display_promo_amount = Number(promo_amount).toFixed(2).replace('.00', '');
      var qual_addr = store.get('qualified_address').toJS();
      var postal = store.get('postal_address').toJS();

      if(qual_addr.unit) {
        qual_addr.address = qual_addr.address + ', ' + qual_addr.unit;
      } else if (qual_addr.LocationValue1){
          qual_addr.address = (qual_addr.LocationDesignator1 ? qual_addr.address + ', ' + qual_addr.LocationDesignator1 + ' '+ qual_addr.LocationValue1 : qual_addr.address + ', ' + qual_addr.LocationValue1);
      }

      if (this.state.standardSelected == "standard") {
        product = standard_product;
      }else if (this.state.standardSelected == "gpon_voice"){
        product = gpon_voice_product;
    }


      const currentYear = new Date().getFullYear();
      const yearsInBusiness = currentYear - 1994;

      let prequal_key = '';
      if(store.get('sso_user')) {
        prequal_key = <div>Prequal Key: {store.get('async_id')}</div>
      }

      if (promo_name =='5-for-12' || promo_name =='10-for-12' || promo_name =='20-for-12') {
        product.promo.terms_product = '';
      }

      let collectEmail = false;
      if (!store.get('sso_user')) {
        collectEmail = true;
      }

    return (
      <div>
      {( 1 ? (
      <div>

<div className="snc-signup-fixed-cta">
  <div className="container" style={{display:'flex', direction:'rtl'}}>
    {(
      test_product && test_product.secret_menu == 1 ? <div style={{width:'150px'}}><a className="snc-btn snc-btn--sm" onClick={this.selectProduct.bind(null, test_product,collectEmail)}>Test Drive</a></div> : <div></div>
    )}
     {( collectEmail ? '':
    <div>
      <a className="snc-btn snc-btn--sm" onClick={this.selectProduct.bind(null, product,collectEmail)}>{t('common:fiberOnly.btn_text')}</a>
    </div>
     )}
    {(
     store.get('sso_user') ? <div style={{width:'150px'}}><a className="snc-btn snc-btn--sm" href={'https://sontec.sontrak.net/sontec-ng/ticket/create/qual/?prequal_key=' + store.get('async_id')} target="_blank">Qual Issue</a></div> : <div></div>
    )}
  </div>
</div>

<div className="snc-section--signup-offer">
  <div className="container">
    <p className="offer">
      {(product.promo && display_promo_amount && display_promo_amount != 0
          ? <span className="offer__special">Save ${Math.round(display_promo_amount)} for {display_promo_duration} {banner_addition ? " + " : ""}{banner_addition}</span>
          : <span></span>
      )}
      {(false ? '' : <span className="offer__regular">({ ( t('common:regular_price').replace('{price}', productRegularPrice) )})</span> )}
    </p>
    {( (product.promo && product.promo.terms_product && product.promo.terms_product != '')   ?
      <p className="coupon">
        <span className="coupon__detail">{( coupon_banner )}</span>
      </p> : ''
    )}
  </div>
</div>

<div className="snc-section--signup-hero">
  <div className="content">
    <h1>{t('common:fiberOnly.great_news')}</h1>
    <div className="result">{t('common:fiberOnly.yo_hood')}</div>
    <div className="address">{t('common:we_found_addr')} <span className="address-only">{qual_addr.address}, {postal.city ? postal.city : qual_addr.city}, {qual_addr.state} {qual_addr.zip}</span>, Residential (<a onClick={this.backToStepOne}>{t('common:fiberOnly.change_address')}</a>)</div>
    { prequal_key }
  </div>
</div>

<div className="snc-section--signup-cards-fiber-xgs">
    <div className="container">
        <div className="section-header">
        <h2>{t('common:fiberXGSPON.do_more')}</h2>
        <p>{t('common:fiberXGSPON.choose_from')}</p>
        </div>
          <div className="card-group">
            <div className={`fusion-only card ${this.state.standardSelected == "fusion" ? "selected-card" : ""}`} id="fusion-card" onClick={this.highlightProduct.bind(this, "fusion")}>
                <div className="card__recommended">
                    <div className="snc-label">Recommended Service</div>
                </div>
                <div className="card__top">
                <div className="card__header">
                    <h3>Fusion Fiber</h3>
                    <div className="speed">Up to 1 Gigabit</div>
                </div>
                <div className="card__feature-group">
                    <div className="card__support-note">
                        <p>Customer support by phone, SMS, and email</p>
                    </div>
                </div>
                <div className="card__feature-group">
                    <h4>SYMMETRICAL INTERNET</h4>
                    <ul>
                      <li>{t('common:fiberXGSPON.symm_internet_1')}</li>
                      <li>{t('common:fiberXGSPON.symm_internet_2')}</li>
                      <li>{t('common:fiberXGSPON.symm_internet_4')}</li>
                      <li>{t('common:fiberXGSPON.symm_internet_5')}</li>
                      <li>{t('common:fiberXGSPON.symm_internet_9')}</li>
                    </ul>
                </div>
                <div className="card__feature-group">
                    <h4>{t('common:fiberXGSPON.home_phone')}</h4>
                    <ul>
                    <li>{t('common:fiberXGSPON.home_phone_1')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_2')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_3')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_4')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_5')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_6')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_7')}</li>
                    </ul>
                </div>
                </div>
                <div className="card__bottom">
                <div className="card__pricing">
                    <div className="price">${displayPrice}</div>
                    <div className="note">{t('common:fiberXGSPON.price_note')}</div>
                </div>
                <div className="card__indicator"></div>
                </div>
            </div>
            <NutritionLabel product={product} />
        {/* START VOICE ONLY */}
        {( gpon_voice_product && store.get('sso_user')?
              <div className={`card ${this.state.standardSelected == "gpon_voice" ? "selected-card" : ""}`} id="gpon_voice-card" onClick={this.highlightProduct.bind(this, "gpon_voice")}>
                <div className="card__top">
                <div className="card__header">
                    <h3>Voice</h3>
                    <div className="speed">(No Data)</div>
                </div>
                <div className="card__feature-group">
                    <div className="card__support-note">
                        <p>Customer Managed via Member Tools</p>
                    </div>
                </div>
                <div className="card__feature-group">
                <h4>{t('common:fiberXGSPON.home_phone')}</h4>
                    <ul>
                    <li>{t('common:fiberXGSPON.home_phone_1')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_2')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_3')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_4')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_5')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_6')}</li>
                    <li>{t('common:fiberXGSPON.home_phone_7')}</li>
                    </ul>
                </div>
                </div>
                <div className="card__bottom">
                <span className="badge badge-info" style={{backgroundColor:'teal'}} title="Voice Only changes are available to staff only">(Secret Menu - Staff Only)</span>
                <div className="card__pricing">
                    <div className="price">${gpon_voice_pricing}</div>
                    <div className="note">{t('common:fiberXGSPON.voice_only_note')}</div>
                </div>
                <br></br>
                <div className="card__indicator"></div>
                </div>
            </div>
        : ''
        )}
        {/* END VOICE ONLY */}
        </div>
    </div>
</div>


<div className="snc-section--signup-price">
  <div className="container">
    <h2>{t('common:fiberOnly.fastest_afford')}</h2>
    {( collectEmail ? '':
    <div className="text-center">
      <a className="snc-btn" onClick={this.selectProduct.bind(null, product,collectEmail)}>{t('common:fiberOnly.btn_text')}</a>
    </div>
    )}
  </div>
</div>
{( !collectEmail ? '':
<div className="snc-section--signup-contact">
  <div className="container">
    <div className={this.state.emailError ? 'snc-contact-cta has-error': 'snc-contact-cta'}>
      <h2>Enter your email address to order now.</h2>
      <div className="form-group">
        <input type="email" aria-label="Email Address" placeholder="Email Address" className="form-control" name="email" value={this.state.email} onChange={this.handleChange}/>
      </div>
      {(!this.state.emailError ? '':
      <span className="help-block">Please enter valid Email Address</span>
      )}
      <div className="text-center">
        <button className="snc-btn" onClick={this.selectProduct.bind(null, product,collectEmail)}>Get Started</button>
      </div>
    </div>
  </div>
</div>
)}
<div className="snc-section--signup-fiber">
  <div className="container">
    <h2>{t('common:fiberOnly.why_sonic')}</h2>
    <div className="row">
      <div className="col-sm-4">
        <h3>{t('common:fiberOnly.browse_game')}</h3>
        <p>{t('common:fiberOnly.ultra_fast')}</p>
      </div>
      <div className="col-sm-4">
        <h3>{t('common:fiberOnly.more_devices')}</h3>
        <p>{t('common:fiberOnly.connect_many')}</p>
      </div>
      <div className="col-sm-4">
        <h3>{t('common:fiberOnly.ultra_up_down')}</h3>
        <p>{t('common:fiberOnly.whether_you')}</p>
      </div>
    </div>
  </div>
</div>

<div className="snc-section--signup-speed">
  <div className="container">
    <h2>{t('common:fiberOnly.what_you_can')}</h2>
    <div className="row">
      <div className="col-sm-6">
        <img src="https://sonic.com/sites/default/files/upload-v2.svg" alt="Upload" />
      </div>
      <div className="col-sm-6">
        <img src="https://sonic.com/sites/default/files/download-v2.svg" alt="Download" />
      </div>
    </div>
  </div>
</div>

<div className="snc-section--signup-switch">
  <div className="container">
    <h2>{t('common:fiberOnly.switching_easy')}</h2>
    <div className="row">
      <div className="col-sm-4">
        <h3>
          <span>1</span>
        </h3>
        <p>{t('common:fiberOnly.sonic_pay_u')}</p>
      </div>
      <div className="col-sm-4">
        <h3>
          <span>2</span>
        </h3>
        <p>{t('common:fiberOnly.sonic_checkout')}</p>
      </div>
      <div className="col-sm-4">
        <h3>
          <span>3</span>
        </h3>
        <p>{t('common:fiberOnly.try_our_service')}</p>
      </div>
    </div>
  </div>
</div>

<div className="snc-section--signup-cutcord">
  <div className="container">
    <h2>{t('common:fiberOnly.cut_cord')}</h2>
    <p>{t('common:fiberOnly.cut_cord_blob')}</p>
    <p>
      <span className="strike">{t('common:fiberOnly.dvr_fees')}</span>
      <span> • </span>
      <span className="strike">{t('common:fiberOnly.hd_fees')}</span>
      <span> • </span>
      <span className="strike">{t('common:fiberOnly.rental_box_fees')}</span>
      <span> • </span>
      <span className="strike">{t('common:fiberOnly.cancellation_fees')}</span>
      <span> • </span>
      <span className="strike">{t('common:fiberOnly.sports_fees')}</span>
      <span> • </span>
      <span className="strike">{t('common:fiberOnly.local_fees')}</span>
    </p>
  </div>
</div>

<div className="snc-section--signup-wifi-v2">
  <div className="container">
    <div className="row">
      <div className="col-sm-6">
        <div className="content">
          <h2>{t('common:fiberOnly.whole_home')}</h2>
          <p>{t('common:fiberOnly.whole_home_blob')}</p>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="graphic">
          <video
          src="https://www.sonic.com/sites/default/files/eero.mp4"
          poster="https://sonic.com/sites/default/files/2gig-eero.png"
          type="video/mp4"
          preload="auto"
          autoPlay
          loop
          muted
          playsinline
          ></video>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="snc-section--signup-customers">
  <div className="container">
    <h2>{t('common:fiberOnly.our_cust_say')}</h2>
    <div className="row">
      <div className="col-sm-4">
        <div className="quote">
          <p>{t('common:fiberOnly.our_cust_1')}</p>
        </div>
      </div>
      <div className="col-sm-4">
        <div className="quote">
          <p>{t('common:fiberOnly.our_cust_2')}</p>
        </div>
      </div>
      <div className="col-sm-4">
        <div className="quote">
          <p>{t('common:fiberOnly.our_cust_3')}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="snc-section-group--zebra">
  <div className="snc-section--features">
    <div className="container-fluid">
      <div className="row">
        <div className="col-xs-10 col-xs-offset-1 col-sm-3 col-sm-offset-0">
          <h4><span className="snc-period">{t('common:fiberOnly.service_features')}</span></h4>
        </div>
        <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-1">
          <div className="row">
            <div className="col-xs-6 col-sm-5">
              <p>{t('common:fiberOnly.ser_feat_1')}</p>
              <p>{t('common:fiberOnly.ser_feat_2')}</p>
              <p>{t('common:fiberOnly.ser_feat_3')}</p>
              <p>{t('common:fiberOnly.ser_feat_4')}</p>
              <p>{t('common:fiberOnly.ser_feat_5')}</p>
            </div>
            <div className="col-xs-6 col-sm-5 col-sm-offset-2">
              <p>{t('common:fiberOnly.ser_feat_6')}</p>
              <p>{t('common:fiberOnly.ser_feat_7')}</p>
              <p>{t('common:fiberOnly.ser_feat_8')}</p>
              <p>{t('common:fiberOnly.ser_feat_9')}</p>
              <p>{t('common:fiberOnly.ser_feat_10')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="snc-section--values">
    <div className="container-fluid">
      <div className="snc-section-values-row-1">
        <div className="row">
          <div className="col-xs-10 col-xs-offset-1 col-sm-3 col-sm-offset-0">
            <h4><span className="snc-period">{t('common:fiberOnly.diff_kinda')}</span></h4>
          </div>
          <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-1">
            <div className="row">
              <div className="col-xs-12 col-sm-5">
                <h5>{t('common:fiberOnly.lead_cust')}</h5>
                <hr className="snc-separator" />
                <p>{t('common:fiberOnly.lead_cust_blob')}</p>
              </div>
              <div className="col-xs-12 col-sm-5 col-sm-offset-2">
                <h5>{t('common:fiberOnly.int_integ')}</h5>
                <hr className="snc-separator" />
                <p>{t('common:fiberOnly.int_integ_blob')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-4">
          <h5>{t('common:fiberOnly.sup_comm')}</h5>
          <hr className="snc-separator" />
          <p>{t('common:fiberOnly.sup_comm_blob_a')} {yearsInBusiness} {t('common:fiberOnly.sup_comm_blob_b')}</p>
        </div>
      </div>
    </div>
  </div>
</div>

{( collectEmail ? '':
    <div className="text-center">
      <a className="snc-btn" onClick={this.selectProduct.bind(null, product,collectEmail)}>{t('common:fiberOnly.btn_text')}</a>
    </div>
    )}
{( !collectEmail ? '':
<div className="snc-section--signup-contact">
  <div className="container">
    <div className={this.state.emailError ? 'snc-contact-cta has-error': 'snc-contact-cta'}>
      <h2>Enter your email address to order now.</h2>
      <div className="form-group">
        <input type="email" aria-label="Email Address" placeholder="Email Address" className="form-control" name="email" value={this.state.email} onChange={this.handleChange}/>
      </div>
      {(!this.state.emailError ? '':
      <span className="help-block">Please enter valid Email Address</span>
      )}
      <div className="text-center">
        <button className="snc-btn" onClick={this.selectProduct.bind(null, product,collectEmail)}>Get Started</button>
      </div>
    </div>
  </div>
</div>
)}
      </div>

      ) : (

      <div className="row preorder_block" role="33">
        <p className="preorder_block__title">Error.</p>

      </div>
      ))}
      </div>
    );
  }
});

export default  translate('common', { wait: true })(FiberOnly);
